<template>
  <PreviousProviderDecisionView
    v-for="(response, index) in responses"
    :key="index"
    :response="response"
    class="previous-provider-decision"
  />
</template>

<script setup lang="ts">
  import PreviousProviderDecisionView from "@/views/apply/PreviousProviderDecisionView.vue"
  import { usePreviousManuallySubmittedProviderResponses } from "@versatile-credit-apply/composition"

  const responses = usePreviousManuallySubmittedProviderResponses()
</script>
<style scoped>
  @reference "@/main.css";

  .previous-provider-decision {
    @apply bg-white;

    @apply mr-4;
    @apply ml-4;
    @apply mb-4;

    @apply rounded-lg;
    @apply shadow-lg;

    @apply xl:mt-6;
    @apply xl:mb-0;
    @apply xl:ml-6;
    @apply xl:mr-12;
    @apply xl:max-w-[1024px];
  }
</style>
